import {handleActions} from 'redux-actions';
import actions from './notifications.actions';

const reducer = handleActions(
	{
		[actions.notificationsRetrieving]: (state, {payload}) => ({
			...state,
			items: null,
			retrieving: true
		}),
		[actions.notificationsReceived]: (state, {payload}) => ({
			...state,
			items: [...payload],
			retrieving: false
		}),
		[actions.notificationsAdd]: (state, {payload}) => ({
			...state,
			items: state.items
				? [
						...state.items.filter(
							item =>
								!// Notifications are unique by key, type and user
								(item.key === payload.key && item.type === payload.type)
						),
						payload // singular
				  ]
				: [payload]
		}),
		[actions.notificationsDismiss]: (state, {payload}) => ({
			...state,
			items: state.items
				? state.items.filter(
						item =>
							!// Notifications are unique by key, type and user
							(item.key === payload.key && item.type === payload.type)
				  )
				: state.items
		}),
		[actions.notificationsMarkAllViewed]: state => ({
			...state,
			items: state.items
				? state.items.map(item => ({
						...item,
						viewed: true
				  }))
				: state.items
		})
	},
	{
		retrieving: false,
		items: null
	}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/user/notifications.reducer.js